import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Analytics } from 'packages';
import { HOVER_MENUS } from './hover-menu/constants';
import {
    selectPreferredCurrency,
    selectShowCurrencySelection
} from 'tradera-state/multi-currency';
import {
    selectPreferredLanguage,
    selectShowLanguageSelection,
    selectShowLanguageSelectionTooltip,
    selectShowLanguageSelectionOptoutTooltip,
    dismissLanguageTooltip,
    dismissLanguageOptoutTooltip
} from 'tradera-state/language';
import HoverMenu from 'components/site-header/hover-menu/hover-menu';
import { LocalizationMenu } from 'components/localization/localization-menu';
import {
    BetaLocalizationTooltip,
    OptinLocalizationTooltip
} from './localization-link-tooltip';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';

import 'components/localization/localization.scss';

const LocalizationLink = ({
    onClick,
    onBlur,
    showMenu,
    preferredCurrency,
    showCurrencySelection,
    preferredLanguage,
    showLanguageSelection,
    showTooltip,
    showOptoutTooltip,
    onCloseTooltip,
    onCloseOptoutToolTip
}) => (
    <div
        className={`tooltip_container position-static tooltip-toggle ${
            showTooltip || showOptoutTooltip ? 'tooltip-toggle-show' : ''
        }`}>
        <div
            className={`btn btn-link-branded px-1 px-sm-3 d-flex align-items-center ${
                showMenu ? 'active' : ''
            }`}
            tabIndex="-1"
            onBlur={onBlur}
            onClick={e => {
                Analytics.trackEvent({
                    category: 'Top navigation',
                    action: 'Localization menu',
                    label: 'Open/Close'
                });
                onClick(e, HOVER_MENUS.LOCALIZATION);
            }}>
            <span className="localization-link-label slim-header__link-text pl-0 pl-lg-2">
                {showLanguageSelection && (
                    <span className="d-block d-sm-inline">
                        {preferredLanguage.languageCodeIso3}
                        {showCurrencySelection && (
                            <span className="d-none d-sm-inline"> / </span>
                        )}
                    </span>
                )}
                {preferredCurrency && preferredCurrency.shortName}
            </span>
            <DropdownIcon className="icon icon-xs align-baseline ml-1" />
        </div>
        <HoverMenu showMenu={showMenu} className="hover-localization-menu mt-4">
            <LocalizationMenu
                idPrefix="site-header"
                showCurrencySelection={showCurrencySelection}
                onCurrencySelected={(code, e) => {
                    onBlur(e, HOVER_MENUS.LOCALIZATION);
                }}
                showLanguageSelection={showLanguageSelection}
                onLanguageSelected={(code, e) => {
                    onBlur(e, HOVER_MENUS.LOCALIZATION);
                }}
            />
        </HoverMenu>
        <BetaLocalizationTooltip show={showTooltip} onClose={onCloseTooltip} />
        <OptinLocalizationTooltip
            show={showOptoutTooltip}
            onClose={onCloseOptoutToolTip}
        />
    </div>
);

LocalizationLink.propTypes = {
    onClick: PropTypes.func.isRequired,
    showMenu: PropTypes.bool.isRequired,
    preferredCurrency: PropTypes.object,
    showCurrencySelection: PropTypes.bool.isRequired,
    preferredLanguage: PropTypes.object,
    showLanguageSelection: PropTypes.bool.isRequired,
    showTooltip: PropTypes.bool
};

LocalizationLink.defaultProps = {
    showTooltip: false
};

const mapStateToProps = state => ({
    preferredCurrency: selectPreferredCurrency(state),
    showCurrencySelection: selectShowCurrencySelection(state),
    preferredLanguage: selectPreferredLanguage(state),
    showLanguageSelection: selectShowLanguageSelection(state),
    showTooltip: selectShowLanguageSelectionTooltip(state),
    showOptoutTooltip: selectShowLanguageSelectionOptoutTooltip(state)
});

const mapDispatchToProps = {
    onCloseTooltip: dismissLanguageTooltip,
    onCloseOptoutToolTip: dismissLanguageOptoutTooltip
};

export const ConnectedLocalizationLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(LocalizationLink);
